export const APP_SECONDARY_THEME_COLOR = "#28558B";
export const DENTIST_PRIMARY_THEME_COLOR = "#F3F4F6";
export const DENTIST_LIGHT_BLUE="#396aa8";
export const APP_THEME_TEN = "white";
export const APP_LIGHTER_PRIMARY_THEME = "#28558B";
export const APP_THEME_TWELVE = "#062347";
export const APP_THEME_THIRTEEN = "#28558B";
export const APP_THEME_FOURTEEN = "#082140";
export const SECONDARY_THEME_COLOR = "#054fbd";


/* Blacks */
export const BLACK = "#000000";
export const FORM_INPUBOX_COLOR = "#2E3D4B";
export const BLACK_TEXT_BOLD = "#262626";
export const MIDNIGHT_EXPRESS = "#00000040";

/* Blues */
export const SKY_BLUE = "#F0F5F7";
export const PACIFIC_BLUE = "#0288D1";

/* Greens */
export const VALIDATE_PASSWORD = "#6EB983";
export const PASSWORD_MATCHED = "#0B9743";
export const LIGHT_GREEN = "#DFF6E8";
export const VIBRANT_GREEN = "#5FD48E";
export const ACTIVE_GREEN = "#41A96B";
export const BUDGREEN = "#87b44d";
export const GREEN_TEAL = "#0DB74C";
export const LUMINESCENT_GREEN = "#639f17";
export const OLD_GOLD = "#bdbd34";
export const YELLOWISH_GREEN = "#bdbd34";

/* Greys */
export const BORDER_GREY = "#CCCCCC";
export const LIGHT_GREY = "#65696D";
export const VERY_LIGHTGREY = "#D3D3D3";
export const DISABLE_GREY = "#aaaaaa";
export const DARK_GREY = "#D5D5D5";
export const SEPERATOR_GREY = "#EBE5DB";
export const SILVER_GREY = "#DADADA";
export const METALLIC_SILVER = "#BFBFBF";
export const LIGHTER_GREY = "#6F6C6A";
export const CLASSIC_GREY = "#C4C4C4";
export const TEXT_GREY = "#918F8D";
export const NIGHT_GREY = "#505050";
export const GREY78 = "#C7C7C7";
export const GREY91 = "#E8E8E8";
export const GREY95 = "#f2f2f2";
export const GREY97 = "#F7F7F7";
export const GREY98 = "#FAFAFA";
export const BRIGHT_GREY = "#E8EBEA";
export const DIM_GREY = "#696969";
export const WHITE_SMOKE = "#F0F0F0";
export const ONVISIA_GREY = "#d5d3d3";
export const TRANSPARENT_GREY = "#F8F8F8";
export const VERY_LIGHT_GREY = "#ECECE";
export const GREY_CHATEAU = "#A1A6AB";
export const PLATINUM_SILVER = "#CECECE";
export const GREY77 = "#777777";
export const LIGHT_GREY_SHADE = "#F2F4FC";
export const FADED_GREY = "#0000001f";
export const DIMGREY = "#6a6a6a";
export const PAYNEGREY = "#404041";
export const DOLPHIN_GREY = "#7676801F";
export const GREY_SUIT = "#8E8E93";
export const ANTI_FLASH_WHITE = "#E7EAED";

/* Browns */
export const ECLIPSE = "#3F3A3B";
export const GONDOLA = "#3E3B3A;";
export const JON = "3E3A3B";
export const BROWN_HEADING = "#555453";

/* Purples */
export const HOT_PURPLE = "#57275E";

/* Reds */
export const ALERT_USER = "#EE3C3C";
export const RED_RATING = "#E2582D";
export const TEXT_RED = "#E3582D";
export const BERN_RED = "#DA3C08";
export const BRIGHT_RED = "#FB3232";
export const LIGHT_RED = "#EB6A6A";
export const VENETION_RED = "#FA4545";
export const MISTY_ROSE = "#FEE6E6";
export const BIZZARE_RED = "#f2dede";
export const APPLE_BLOSSOM_RED = "#a94442";

/* Whites */
export const WHITE = "#ffffff";
export const DUSTY_WHITE = "#F6F5F1";

/* Yellows */

/* VIOLET */
export const CRAYOLA = "#91288f";

/* Oranges */
export const ORANGE_PEEL = "#f59d40";
export const WARM_ORANGE = "#ea6225";
export const DEEP_ORANGE = "#ff9200";
export const DARK_ORANGE = "#ff9200";

